import { recordConsent } from "./consentApi"

export const CONSENT_KEY = "forgelight-cookie-consent"
export const CONSENT_VERSION = "1"
const CONSENT_MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000

export const DEFAULT_PREFS = {
  necessary: true,
  analytics: false,
  functional: false,
  advertising: false,
  identityResolution: false,
}

export function readStoredConsent() {
  if (typeof window === "undefined") return null
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed.version !== CONSENT_VERSION) return null
    if (Date.now() - new Date(parsed.timestamp).getTime() > CONSENT_MAX_AGE_MS)
      return null
    return parsed
  } catch {
    return null
  }
}

export function writeStoredConsent(prefs) {
  if (typeof window === "undefined") return
  window.localStorage.setItem(
    CONSENT_KEY,
    JSON.stringify({
      version: CONSENT_VERSION,
      prefs,
      timestamp: new Date().toISOString(),
    })
  )
}

export function hasGPCSignal() {
  if (typeof navigator === "undefined") return false
  return navigator.globalPrivacyControl === true
}

export function applyConsent(finalPrefs) {
  if (typeof window === "undefined") return
  window.forgelightConsent = finalPrefs
  window.dispatchEvent(
    new CustomEvent("forgelight-consent-updated", { detail: finalPrefs })
  )
}

export function commitConsent(prefs, { gpcDetected = false, source } = {}) {
  writeStoredConsent(prefs)
  applyConsent(prefs)
  recordConsent({ prefs, gpcDetected, source })
}

export function isOptedOutOfSaleSharing() {
  const stored = readStoredConsent()
  if (stored)
    return (
      stored.prefs.advertising !== true ||
      stored.prefs.identityResolution !== true
    )
  return true
}